import { NavBarGroup } from "./NavBarGroup";

import "./NavBar.css";

import type { ReactNode } from "react";

export interface NavBarProps {
  children?: ReactNode;
}

export function NavBar({ children }: NavBarProps) {
  return <div className="NavBar">{children}</div>;
}

NavBar.Group = NavBarGroup;
